import entries from './reducers';

export { default as EntriesOperations } from './operations';
export { default as EntriesSelectors } from './selectors';

export default entries;
